module.exports = __webpack_public_path__ + "img/ic-screens-active.f5bcb652.svg";